module.exports = __webpack_public_path__ + "static/media/parisian-pauline.60290812.png";